import React from 'react';
import { Search, Filter, Edit2, ShieldAlert } from 'lucide-react';
const MOCK_DATA = [{
  id: 1,
  emp: 'John Doe',
  date: '2023-10-12',
  shift: 'Morning',
  in: '05:55 AM',
  out: '02:05 PM',
  hours: '8h 10m',
  status: 'Present'
}, {
  id: 2,
  emp: 'Sarah Smith',
  date: '2023-10-12',
  shift: 'Evening',
  in: '02:15 PM',
  out: '10:00 PM',
  hours: '7h 45m',
  status: 'Late'
}, {
  id: 3,
  emp: 'Mike Johnson',
  date: '2023-10-12',
  shift: 'Night',
  in: '-',
  out: '-',
  hours: '-',
  status: 'Absent'
}, {
  id: 4,
  emp: 'Emily Davis',
  date: '2023-10-12',
  shift: 'Morning',
  in: '06:00 AM',
  out: '10:00 AM',
  hours: '4h 0m',
  status: 'Half Day'
}, {
  id: 5,
  emp: 'Robert Wilson',
  date: '2023-10-12',
  shift: 'Morning',
  in: '05:50 AM',
  out: '02:10 PM',
  hours: '8h 20m',
  status: 'Present'
}, {
  id: 6,
  emp: 'Lisa Taylor',
  date: '2023-10-11',
  shift: 'Evening',
  in: '01:55 PM',
  out: '10:05 PM',
  hours: '8h 10m',
  status: 'Present'
}, {
  id: 7,
  emp: 'David Brown',
  date: '2023-10-11',
  shift: 'Morning',
  in: '06:30 AM',
  out: '02:00 PM',
  hours: '7h 30m',
  status: 'Late'
}];
const STATUS_COLORS: Record<string, string> = {
  Present: 'bg-green-100 text-green-700 border-green-200',
  Absent: 'bg-red-100 text-red-700 border-red-200',
  Late: 'bg-yellow-100 text-yellow-700 border-yellow-200',
  'Half Day': 'bg-blue-100 text-blue-700 border-blue-200'
};
export function AttendanceManagement() {
  return <div className="p-6 max-w-7xl mx-auto space-y-6" data-id="element-1165">
      {/* Filters */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4" data-id="element-1166">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-end" data-id="element-1167">
          <div data-id="element-1168">
            <label className="block text-xs font-semibold text-gray-500 uppercase mb-1.5" data-id="element-1169">
              Start Date
            </label>
            <input type="date" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-indigo-500 focus:border-indigo-500 outline-none" data-id="element-1170" />
          </div>
          <div data-id="element-1171">
            <label className="block text-xs font-semibold text-gray-500 uppercase mb-1.5" data-id="element-1172">
              End Date
            </label>
            <input type="date" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-indigo-500 focus:border-indigo-500 outline-none" data-id="element-1173" />
          </div>
          <div data-id="element-1174">
            <label className="block text-xs font-semibold text-gray-500 uppercase mb-1.5" data-id="element-1175">
              Department
            </label>
            <select className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-indigo-500 focus:border-indigo-500 outline-none bg-white" data-id="element-1176">
              <option data-id="element-1177">All Departments</option>
              <option data-id="element-1178">Engineering</option>
              <option data-id="element-1179">HR</option>
              <option data-id="element-1180">Operations</option>
            </select>
          </div>
          <div data-id="element-1181">
            <label className="block text-xs font-semibold text-gray-500 uppercase mb-1.5" data-id="element-1182">
              Status
            </label>
            <select className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-indigo-500 focus:border-indigo-500 outline-none bg-white" data-id="element-1183">
              <option data-id="element-1184">All Status</option>
              <option data-id="element-1185">Present</option>
              <option data-id="element-1186">Absent</option>
              <option data-id="element-1187">Late</option>
              <option data-id="element-1188">Half Day</option>
            </select>
          </div>
          <div data-id="element-1189">
            <button className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors" data-id="element-1190">
              <Search size={16} data-id="element-1191" />
              Search
            </button>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1192">
        <div className="overflow-x-auto" data-id="element-1193">
          <table className="w-full text-sm text-left" data-id="element-1194">
            <thead className="bg-gray-50 text-xs font-semibold text-gray-600 uppercase border-b border-gray-200" data-id="element-1195">
              <tr data-id="element-1196">
                <th className="px-6 py-4" data-id="element-1197">Employee</th>
                <th className="px-6 py-4" data-id="element-1198">Date</th>
                <th className="px-6 py-4" data-id="element-1199">Shift</th>
                <th className="px-6 py-4" data-id="element-1200">Check In</th>
                <th className="px-6 py-4" data-id="element-1201">Check Out</th>
                <th className="px-6 py-4" data-id="element-1202">Hours</th>
                <th className="px-6 py-4" data-id="element-1203">Status</th>
                <th className="px-6 py-4 text-center" data-id="element-1204">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-1205">
              {MOCK_DATA.map(row => <tr key={row.id} className="hover:bg-gray-50 transition-colors" data-id="element-1206">
                  <td className="px-6 py-4 font-medium text-gray-900" data-id="element-1207">
                    {row.emp}
                  </td>
                  <td className="px-6 py-4 text-gray-600" data-id="element-1208">{row.date}</td>
                  <td className="px-6 py-4 text-gray-600" data-id="element-1209">{row.shift}</td>
                  <td className="px-6 py-4 font-mono text-gray-700" data-id="element-1210">
                    {row.in}
                  </td>
                  <td className="px-6 py-4 font-mono text-gray-700" data-id="element-1211">
                    {row.out}
                  </td>
                  <td className="px-6 py-4 font-mono font-medium text-gray-900" data-id="element-1212">
                    {row.hours}
                  </td>
                  <td className="px-6 py-4" data-id="element-1213">
                    <span className={`px-2.5 py-1 rounded-full text-xs font-bold border ${STATUS_COLORS[row.status]}`} data-id="element-1214">
                      {row.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-center" data-id="element-1215">
                    <div className="flex items-center justify-center gap-2" data-id="element-1216">
                      <button className="p-1.5 text-gray-400 hover:text-indigo-600 hover:bg-indigo-50 rounded transition-colors" title="Edit" data-id="element-1217">
                        <Edit2 size={16} data-id="element-1218" />
                      </button>
                      <button className="p-1.5 text-gray-400 hover:text-orange-600 hover:bg-orange-50 rounded transition-colors" title="Manual Override" data-id="element-1219">
                        <ShieldAlert size={16} data-id="element-1220" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between bg-gray-50" data-id="element-1221">
          <span className="text-sm text-gray-500" data-id="element-1222">
            Showing 1 to 7 of 42 entries
          </span>
          <div className="flex gap-1" data-id="element-1223">
            <button className="px-3 py-1 border border-gray-300 rounded bg-white text-gray-500 hover:bg-gray-50 text-sm" data-id="element-1224">
              Prev
            </button>
            <button className="px-3 py-1 border border-indigo-600 rounded bg-indigo-600 text-white text-sm" data-id="element-1225">
              1
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded bg-white text-gray-500 hover:bg-gray-50 text-sm" data-id="element-1226">
              2
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded bg-white text-gray-500 hover:bg-gray-50 text-sm" data-id="element-1227">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>;
}